import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { environment } from '@navfleet/shared/core/environment';
import { provideStoreDevtools } from '@ngrx/store-devtools';

export const provideStoreDevtoolsBaseOnEnv = (): EnvironmentProviders =>
    environment.production
        ? makeEnvironmentProviders([])
        : provideStoreDevtools({
              name: `NavFleet (${globalThis.location?.hostname ?? 'unknown'})`,
              maxAge: 25,
              connectInZone: true,
          });
